<template lang="pug">
div(v-if="cadastroFormulario.interessado")
  el-row
    div.center
      p.titulo-resumo Resumo do Cadastro
    el-col(:span="24")
      app-resumo-cadastrante(v-if="cadastroFormulario.cadastrante" :cadastrante="cadastroFormulario.cadastrante")
      app-resumo-interessado(
        v-if="cadastroFormulario.interessado"
        :interessado="cadastroFormulario.interessado",
      )
      resumo-imovel(v-if="cadastroFormulario.imovel" :imovel="cadastroFormulario.imovel", :cadastro="cadastroFormulario" :tipo="tipoProcesso")
      app-resumo-destinacao-uso-imovel(v-if="cadastroFormulario.destinacaoUsoImovel" :destinacaoUsoImovel="cadastroFormulario.destinacaoUsoImovel")
      app-resumo-geo(v-if="cadastroFormulario.georreferenciamento" :geo="cadastroFormulario.georreferenciamento")
</template>
<script>
import AppResumoCadastrante from './resumos/AppResumoCadastrante'
import AppResumoInteressado from './resumos/AppResumoInteressado'
import AppResumoDestinacaoUsoImovel from './resumos/AppResumoDestinacaoUsoImovel'
import ResumoImovel from './ResumoImovel'
import AppResumoGeo from './resumos/AppResumoGeo.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'

import AppButton from '@/components/shared/AppButton'

export default {
  components: {
    AppButton,
    AppResumoCadastrante,
    AppResumoInteressado,
    ResumoImovel,
    AppResumoDestinacaoUsoImovel,
    AppResumoGeo
  },

  props: ['cadastro', 'idProcesso'],

  data () {
    return {
      cadastroFormulario: {},
      tipoProcesso: ''
    }
  },

  async activated () {
    // Atualiza os dados do cadastro ao ativar o componente
    const jsonCadastro = await this.findByIdCadastro(this.idProcesso)
    this.CADASTRO_INICIAL(JSON.parse(jsonCadastro.json))
    const objetoFormulario = JSON.parse(jsonCadastro.json)
    this.cadastroFormulario = JSON.parse(JSON.stringify(this.cadastroJson))
    this.tipoProcesso = objetoFormulario.tipo
  },

  computed: {
    ...mapGetters({
      cadastroJson: 'retificacao/cadastro'
    })
  },

  methods: {
    ...mapActions({
      findByIdCadastro: 'cadastro/findCadastroById'
    }),
    ...mapMutations('retificacao', ['CADASTRO_INICIAL'])
  }
}
</script>
<style lang="scss" scoped>

.center {
  display: flex;
  justify-content: center;
}

.titulo-resumo {
  font-size: 25px;
  font-weight: bold;
  color: green !important;
}

</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/para/retificacao/components/Resumo.vue